import script from "./ScrolledText.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrolledText.vue?vue&type=script&setup=true&lang=js"

import "./ScrolledText.vue?vue&type=style&index=0&id=1bc6652e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc6652e"]])

export default __exports__